import React from 'react';
import AttendanceManagement from '../components/AttendanceManagement';

const AttendanceManagementPage = () => {
    return <AttendanceManagement />;
};

export default AttendanceManagementPage;